import { render } from "./ListadoUsuarios.vue?vue&type=template&id=ed4ab5f8"
import script from "./ListadoUsuarios.vue?vue&type=script&lang=js"
export * from "./ListadoUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__